<template>
  <div container>
    <div class="card _mbs _ps">
      <div grid="row wrap">
        <div container>
          <h4>Filter By</h4>
        </div>
      </div>
      <div grid="row wrap">
        <div column="3" class="_mbxs" v-for="(field, i) in filterFormFields" :key="i">
          <label :for="field.id">{{ field.label }}</label>
          <template v-if="field.options">
            <select :name="field.id" :id="field.id" :value="[field.id]">
              <option v-for="option in field.options" :value="option">{{ selectDropdownLabel(option) }}</option>
            </select>
          </template>
          <date-input
            v-else-if="field.type === 'date'"
            :value="field.id"
            v-model="field.id"
            format="MM/DD/YYYY"
          />
          <template v-else>
            <input :id="field.id" :name="field.id" :type="field.type">
          </template>
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mts" column="4 +4">
          <button class="btn white --sm _mrxs" @click="$emit('toggleFilterForm')">Cancel</button>
          <button class="btn --sm" @click="$emit('toggleFilterForm')">Filter</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { selectDropdownLabel } from '@/js/utilities'
  import DateInput from '@atoms/DateInput'

  export default {
    props: {
      filterFormFields: {
        required: true,
        type: Array
      }
    },
    components: {
      DateInput
    },
    methods: {
      selectDropdownLabel
    }
  }
</script>
